import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SecurityHeadersService {

  constructor() {
    this.injectSecurityHeaders();
  }

  private injectSecurityHeaders(): void {
    // ✅ Headers de seguridad configurados correctamente en server.js del workflow
    // Configuración centralizada para evitar conflictos y duplicaciones
  }

  private setMetaTag(name: string, content: string): void {
    // Buscar si ya existe un meta tag con este nombre
    let existingTag = document.querySelector(`meta[http-equiv="${name}"]`) as HTMLMetaElement;
    
    if (existingTag) {
      // Actualizar contenido existente
      existingTag.content = content;
    } else {
      // Crear nuevo meta tag
      const meta = document.createElement('meta');
      meta.setAttribute('http-equiv', name);
      meta.setAttribute('content', content);
      document.getElementsByTagName('head')[0].appendChild(meta);
    }
  }

  // Método público para verificar headers
  public verifyHeaders(): void {
    const headers = document.querySelectorAll('meta[http-equiv]');
    headers.forEach(header => {
      const name = header.getAttribute('http-equiv');
      const content = header.getAttribute('content');
    });
  }
}